import { QueryClient } from "@tanstack/react-query"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      gcTime: 5 * 60 * 1000, // Keep unused data in cache for 5 minutes
      refetchOnWindowFocus: true,
      retry: 1,
      retryDelay: 1000,
      // Show stale data while refetching in background
      placeholderData: (previousData) => previousData,
      // Network mode: always attempt fetch even if offline detection thinks we're offline
      networkMode: 'always',
    },
  },
})
